enum TimeOptions {
  DEFAULT = '',
  DAY = 'In the last day',
  WEEK = 'In the last week',
  MONTH = 'In the last month',
}

export default TimeOptions;
